module.exports = __webpack_public_path__ + "img/application-title.d8c45803.png";